import { render, staticRenderFns } from "./order_status_chart.vue?vue&type=template&id=601be0f4&"
import script from "./order_status_chart.vue?vue&type=script&lang=coffee&"
export * from "./order_status_chart.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports